import React, {useMemo} from 'react'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import {FilterDisplayContainer} from 'components/FilterDisplayContainer/FilterDisplayContainer'
import {filterMessages} from 'components/Filters/filterMessages'
import {NeighborhoodFilter} from 'components/Filters/NeighborhoodFilter'
import {getFacetFilterPillLabel} from 'components/Filters/utils'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {getNeighborhoods} from 'modules/sapiSearch/selectors'
import {toArray} from 'utils/object'

interface Props {
  isActive?: boolean
}

const filterKeys = ['neighborhoodIds']

export const NeighborhoodFilterPopover: React.FC<Props> = ({
  isActive = false
}) => {
  const {formatMessage} = useIntl()
  const {
    submitFilters,
    getFilters,
    toggleMultiFilter,
    clearFilters,
    resetFilters,
    trackFilterClick,
    getAppliedFilters
  } = useFiltersForm(filterKeys)

  const filters = getFilters()
  const appliedFilters = getAppliedFilters()
  const neighborhoods = useSelector(getNeighborhoods)

  const {neighborhoodIds, appliedNeighborhoodIds} = useMemo(() => {
    return {
      neighborhoodIds: toArray(filters.neighborhoodIds),
      appliedNeighborhoodIds: toArray(appliedFilters.neighborhoodIds)
    }
  }, [filters, appliedFilters])

  const neighborhoodLabel = useMemo(
    () =>
      getFacetFilterPillLabel(
        neighborhoods,
        appliedNeighborhoodIds,
        formatMessage(filterMessages.neighborhood)
      ),
    [appliedNeighborhoodIds, neighborhoods, formatMessage]
  )

  if (neighborhoods?.length === 0 || !neighborhoodLabel) return null

  return (
    <FilterDisplayContainer
      dataId="neighborhoodFilter"
      label={neighborhoodLabel}
      title={formatMessage(filterMessages.neighborhood)}
      isActive={isActive}
      onClear={clearFilters}
      onApply={submitFilters}
      onClose={resetFilters}
      onPillClick={trackFilterClick}
    >
      <NeighborhoodFilter
        neighborhoods={neighborhoods}
        selectedNeighborhoodIds={neighborhoodIds}
        onChange={toggleMultiFilter}
        isExpandable={false}
        variant="two-columns"
      />
    </FilterDisplayContainer>
  )
}
